function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3757",
  "data-name": "Group 3757",
  transform: "translate(-719 -720.737)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-flow-1393629",
  transform: "translate(719 720.737)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12109",
  "data-name": "Path 12109",
  d: "M15.343,287.055C8.391,292.68,6.233,284.926,0,289.564,6.353,282.95,8.691,290.552,15.343,287.055Z",
  transform: "translate(0 -286.751)",
  fill: "#af700b"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun-flow-1393629-2",
  "data-name": "noun-flow-1393629",
  transform: "translate(720.657 724.33)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12109-2",
  "data-name": "Path 12109",
  d: "M15.343,287.055C8.391,292.68,6.233,284.926,0,289.564,6.353,282.95,8.691,290.552,15.343,287.055Z",
  transform: "translate(0 -286.751)",
  fill: "#af700b"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun-flow-1393629-3",
  "data-name": "noun-flow-1393629",
  transform: "translate(719 727.924)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12109-3",
  "data-name": "Path 12109",
  d: "M15.343,287.055C8.391,292.68,6.233,284.926,0,289.564,6.353,282.95,8.691,290.552,15.343,287.055Z",
  transform: "translate(0 -286.751)",
  fill: "#af700b"
})));

var SvgGroup3757 = function SvgGroup3757(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup3757, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group 3757.10ee10ad.svg";
export { ForwardRef as ReactComponent };